import { useEffect } from "react";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { useAuthStore } from "@/lib/auth-store";
import { AppRoutes } from "./routes";

export function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const status = useAuthStore((s) => s.status);

  useEffect(() => {
    if (status === "idle") void bootstrap();
  }, [bootstrap, status]);

  return (
    <ErrorBoundary>
      <AppRoutes />
    </ErrorBoundary>
  );
}
